// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1057V","error":"Textarea_error__sgPvX","readonly":"Textarea_readonly__13A2G","disabled":"Textarea_disabled__iZVMQ"};